import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaProjectDetailsQuery = (
  projectId: MaybeRefOrGetter<string>,
) =>
  useQuery({
    queryKey: computed(() =>
      projectKeys.details({ projectId: toValue(projectId) }),
    ),
    queryFn: () => projectService.getProjectDetails(toValue(projectId)),
    enabled: computed(() => !!toValue(projectId)),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
